import { useApiQuery } from '~/hooks';
import {
  getCreditBalanceApi,
  getCreditStatsApi,
  getCreditUsageOverviewApi,
} from '../repository';

export const CREDIT_QUERY_KEYS = {
  CREDIT_BALANCE: 'credit-balance',
  CREDIT_STATS: 'credit-stats',
  CREDIT_USAGE_OVERVIEW: 'credit-usage-overview',
};

/**
 * Query hook to fetch user's credit balance
 */
export const useGetCreditBalanceQuery = () => {
  return useApiQuery({
    queryKey: [CREDIT_QUERY_KEYS.CREDIT_BALANCE],
    queryFn: () => getCreditBalanceApi(),
  });
};

/**
 * Query hook to fetch user's credit statistics for stats cards
 */
export const useGetCreditStatsQuery = () => {
  return useApiQuery({
    queryKey: [CREDIT_QUERY_KEYS.CREDIT_STATS],
    queryFn: () => getCreditStatsApi(),
  });
};

/**
 * Query hook to fetch user's credit usage overview for the last 6 months
 */
export const useGetCreditUsageOverviewQuery = () => {
  return useApiQuery({
    queryKey: [CREDIT_QUERY_KEYS.CREDIT_USAGE_OVERVIEW],
    queryFn: () => getCreditUsageOverviewApi(),
  });
};
